import mergeDefaultProps from "@gef-ui/utils/mergeDefaultProps";
import mergeAll from "ramda/es/mergeAll";
import mergeDeepLeft from "ramda/es/mergeDeepLeft";
import rProps from "ramda/es/props";
import React, { createContext, useContext, useMemo } from 'react';
const GlobalDefaultContext = /*#__PURE__*/ createContext({});
export const Provider = GlobalDefaultContext.Provider;
export const ModifyContextProvider = ({ value, mergeFn = mergeDeepLeft, children })=>{
    const globalDefault = useContext(GlobalDefaultContext);
    const finalValue = mergeFn(value, globalDefault);
    return /*#__PURE__*/ React.createElement(Provider, {
        value: finalValue
    }, children);
};
export function getPropsFromSlice(globalDefault, sliceCorrect, sliceDeprecated = []) {
    const deprecatedSlice = sliceDeprecated.find((sliceName)=>globalDefault?.props?.[sliceName]);
    if (deprecatedSlice) {
        console.warn(`Slice ${sliceDeprecated} is deprecated, use ${sliceCorrect} instead`);
    }
    return globalDefault?.props?.[deprecatedSlice || sliceCorrect];
}
export function useDefaultValue({ inProps, slice, sliceDeprecated, components }) {
    const globalDefault = useContext(GlobalDefaultContext);
    // biome-ignore lint/correctness/useExhaustiveDependencies: components should never changes
    const defaultProps = useMemo(()=>{
        const sliceProps = getPropsFromSlice(globalDefault, slice, sliceDeprecated);
        if (!sliceProps) {
            return {};
        } else {
            const test = rProps(Array.isArray(components) ? components : [
                components
            ], sliceProps);
            return mergeAll(test);
        }
    }, [
        globalDefault
    ]);
    return mergeDefaultProps(inProps, defaultProps);
}
export function useStateManagementSlice(slice) {
    const globalDefault = useContext(GlobalDefaultContext);
    return useMemo(()=>globalDefault?.stateManagement?.[slice], [
        globalDefault,
        slice
    ]);
}
export function useRouterSlice(slice) {
    const globalDefault = useContext(GlobalDefaultContext);
    return useMemo(()=>globalDefault?.routing?.[slice], [
        globalDefault,
        slice
    ]);
}
export default GlobalDefaultContext;
